import { render, staticRenderFns } from "./FactSheets.vue?vue&type=template&id=d26d794a"
import script from "./FactSheets.vue?vue&type=script&lang=js"
export * from "./FactSheets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports